<template>
  <div>
    <input type="hidden" id="isPrint" value="false" />
    <input type="hidden" id="hidePrintTitle" value="false" />
    <vs-tabs v-if="tabList.length > 1 || showOneTab" :value="tabIndex">
      <vs-tab v-for="tab in tabList" :key="`tab_${tabLabel(tab.label, 'tab')}`" :label="tabLabel(tab.label, 'tab')" @click="moveTab(tab.boardId, tab.key)"> </vs-tab>
    </vs-tabs>
    <div>
      <component v-if="tab.exception" :is="tab.component" />
      <ApprovalDocument2
        v-else-if="tab.isApproval"
        :tab="tab"
        :doc-info="docInfo"
        :docProjectId="docProjectId"
        :permission="getPermission"
        :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
        :print-direction="tab.printDirection"
        @delete="onClickApprovalDelete"
        @close="onClickApprovalClose"
        @recall="onClickApprovalRecall"
        @upload="onClickApprovalUpload"
        @update="onClickApprovalSave"
        @save="onClickApprovalSave"
        @approval="onClickApprovalOk"
        @reject="onClickApprovalNo"
        @onClickCustomButton="onClickCustomButton"
      >
        <template #header="props">
          <div v-if="tab.useHeaderDate" class="h4 flex" style="align-items: center">
            <div id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tabLabel(tab.label, "writeTitle") }}</p>
            </div>

            <label v-if="tab.headerDateType.indexOf('year') >= 0"  class="flex items-center">
              <ml-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.year" :readonly="props.board.readonly || !!postId" />년
            </label>
            <label v-if="tab.headerDateType.indexOf('month') >= 0"  class="flex items-center">
              <ml-input type="number" class="ml-8 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" :min="1" :max="12" :min-value="1" :max-value="12" />월
            </label>
          </div>

          <div v-else id="print-label">
            <p class="h4 flex" style="align-items: center">{{ tabLabel(tab.label, "writeTitle") }}</p>
          </div>
        </template>

        <template #body="props">
          <component ref="childComponent" :is="tab.component" :tab="tab" :board="props.board" :header="form.header" :is-print="props.isPrint" v-model="form.body" @EnableSave="handleEnableSave" />
          <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
        </template>
      </ApprovalDocument2>
      <NormalDocument
        v-else
        :tab="tab"
        :created="useCreated"
        :docProjectId="docProjectId"
        :permission="getPermission"
        :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
        :print-direction="tab.printDirection"
        @move="onMoveNormalPage"
        @remove="onClickNormalRemove"
        @save="onClickNormalSave"
        @onClickCustomButton="onClickCustomButton"
      >
        <template #header="props">
          <div v-if="tab.useHeaderDate" class="h4 flex" style="align-items: center">
            <div id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tabLabel(tab.label, "writeTitle") }}</p>
            </div>

            <label v-if="tab.headerDateType.indexOf('year') >= 0"  class="flex items-center">
              <ml-input type="number" class="ml-8 mr-2" style="width: 100px" v-model="form.header.year" :readonly="props.board.readonly || !!postId" :min-value="1900" />년
            </label>
            <label v-if="tab.headerDateType.indexOf('month') >= 0"  class="flex items-center">
              <ml-input type="number" class="ml-8 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" :min="1" :max="12" :min-value="1" :max-value="12" />월
            </label>
          </div>
          <div v-else id="print-label">
            <p class="h4 flex" style="align-items: center">{{ tabLabel(tab.label, "writeTitle") }}</p>
          </div>
        </template>
        <template #body="props">
          <component ref="childComponent" :is="tab.component" :tab="tab" :board="props.board" :header="form.header" :is-print="props.isPrint" v-model="form.body" @EnableSave="handleEnableSave" />
          <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
        </template>
      </NormalDocument>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/views/boards/tab/breadcrumb";
import tabItems from "@/views/boards/tab/tab-items";
import Exception01 from "@/views/boards/exception/Exception01";
import Exception02 from "@/views/boards/exception/Exception02";
import Exception03 from "@/views/boards/exception/Exception03";
import Exception04 from "@/views/boards/exception/Exception04";

import ApprovalDocument2 from "@/views/write/document/ApprovalDocument2";
import NormalDocument from "@/views/write/document/NormalDocument";

import FileDownload from "@/components/FileDownload.vue";
import singlePageWrite from "@/views/boards/single-page/writeIndex";

export default {
  name: "Write",
  components: {
    NormalDocument,
    ApprovalDocument2,
    Exception01,
    Exception02,
    Exception03,
    Exception04,
    FileDownload,
  },
  data() {
    return {
      tabItems,
      breadcrumb,
      tabIndex: 0,
      tabList: [],

      oldForm: {},
      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
        },
        body: {},
      },
      docInfo: {},
      docProjectId: "",

      isApproval: false,
      isPrint: false,
      enableSave: true,
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    boardSlug() {
      for (const tab of this.tabList) {
        if (`${tab.boardId}` === `${this.boardId}`) {
          return tab.slug;
        }
      }
      return "";
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    useCreated() {
      // if (this.boardId === ) {
      //
      // }
      return this.enableSave;
    },
    header() {
      return this.form.header;
    },

    memberInfoBoards() {
      if (this.$store.state.member.memberInfo.boards) {
        return this.$store.state.member.memberInfo.boards;
      } else {
        // 정보가 없으면, API에서 불러온다
        this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
      }
    },
    getPermission() {
      let permission = { c: 0, r: 0, u: 0, d: 0, v: 0 };
      const boards = this.memberInfoBoards;

      if (boards) {
        let board = boards.find((b) => parseInt(b.id) === this.boardId);

        if (!!board && !!board.pivot) {
          let pivot = { c: 0, r: 0, u: 0, d: 0, v: 0 };

          if (board.pivot.project_id) {
            board = boards.find((b) => parseInt(b.pivot.board_id) === this.boardId && parseInt(b.pivot.project_id) === this.projectId);
            if (board) {
              pivot = { ...board.pivot };
            }
          } else {
            pivot = { ...board.pivot };
          }
          permission = { c: pivot.c, r: pivot.r, u: pivot.u, d: pivot.d, v: pivot.v };
        }
      }
      return permission;
    },
    tab() {
      return this.tabList[this.tabIndex];
    },
    showOneTab() {
      const enabledIds = [];

      // 탭이 노출되기 원하는 boardId인 경우
      // true를 반환시켜준다.
      return !!enabledIds.find((id) => id === this.boardId);
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.form.header.full = `${value.year}-${value.month > 9 ? value.month : `0${value.month}`}-01`;
        }
      },
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
  },
  beforeMount() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    this.initBreadcrumb();
    this.initBackButtonRouteGuard();
    this.initTab();
  },
  async mounted() {
    this.$refs["btn_안전점검 계획 불러오기"];
    if (this.postId) {
      if (this.isApproval) {
        await this.loadApprovalPost();
      } else {
        await this.loadBoardPost();
      }
    }
  },
  methods: {
    tabLabel(label, type) {
      if (typeof label === "string") return label;
      else if (type === "writeTitle" && label.writeTitle) return label.writeTitle;
      else return label[this.projectId] || label.default;
    },
    initBreadcrumb() {
      let breadcrumb = [{ title: "Home" }];
      let key = `${this.boardId}`;

      // 브래드크럼의 이름이 프로젝트 번호와 연결되어 있으면, 해당 정보를 가져온다
      if (this.breadcrumb[`${this.projectId}.${this.boardId}`]) {
        key = `${this.projectId}.${this.boardId}`;
      }
      breadcrumb.push(...this.breadcrumb[key]);

      if (Number(`${this.projectId}`) === 1) {
        if (this.boardId === 119) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "안전보건총괄책임자 선임" }];
        } else if (this.boardId === 120) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "중대재해예방팀 선임" }];
        } else if (this.boardId === 121) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "안전보건조정자 선임" }];
        } else if (this.boardId === 122) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "안전보건관리자 및 산업보건의 선임" }];
        } else if (this.boardId === 123) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "안전보건관리자 및 산업보건의(건설업) 선임" }];
        } else if (this.boardId === 124) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "안전보건담당자 선임" }];
        } else if (this.boardId === 125) {
          breadcrumb = [{ title: "Home" }, { title: "사업장 등록" }, { title: "관리감독자 선임" }];
        }
      }

      if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
      this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
    },
    initBackButtonRouteGuard() {
      const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
        const isNext = JSON.stringify(this.oldForm) === JSON.stringify(this.form) || confirm("저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?")
        if (isNext) {
          document.querySelectorAll(".con-vs-popup").forEach((el) => {
            el.style.display = "none";
          })
          next(true);
        }
      });
      this.$once("hook:destroyed", () => {
        backButtonRouteGuard();
      });
    },
    initTab() {
      if (this.boardId === 53 || this.boardId === 54 || this.boardId === 55) {
        this.addTab(53);
        this.addTab(54);
        this.addTab(55);
        if (this.boardId === 53) this.tabIndex = 0;
        else if (this.boardId === 54) this.tabIndex = 1;
        else if (this.boardId === 55) this.tabIndex = 2;
      } else if (this.boardId === 58 || this.boardId === 59 || this.boardId === 60) {
        this.addTab(58);
        this.addTab(59);
        this.addTab(60);
        if (this.boardId === 58) this.tabIndex = 0;
        else if (this.boardId === 59) this.tabIndex = 1;
        else if (this.boardId === 60) this.tabIndex = 2;
      } else if (this.boardId === 62 || this.boardId === 63) {
        this.addTab(62);
        this.addTab(63);
        this.addSubTab("아차사고D/B");
        if (this.boardId === 62) this.tabIndex = 0;
        else if (this.boardId === 63) this.tabIndex = 1;
      } else if (this.boardId === 64 || this.boardId === 65 || this.boardId === 66 || this.boardId === 67 || this.boardId === 68 || this.boardId === 69) {
        this.addTab(64);
        this.addTab(65);
        this.addTab(66);
        this.addTab(67);
        this.addTab(68);
        this.addTab(69);
        if (this.boardId === 64) this.tabIndex = 0;
        else if (this.boardId === 65) this.tabIndex = 1;
        else if (this.boardId === 66) this.tabIndex = 2;
        else if (this.boardId === 67) this.tabIndex = 3;
        else if (this.boardId === 68) this.tabIndex = 4;
        else if (this.boardId === 69) this.tabIndex = 5;
      } else if (this.boardId === 71 || this.boardId === 72 || this.boardId === 73 || this.boardId === 74 || this.boardId === 75) {
        this.addTab(74);
        this.addTab(75);
        this.addTab(71);
        this.addTab(72);
        this.addTab(73);
        if (this.boardId === 74) this.tabIndex = 0;
        else if (this.boardId === 75) this.tabIndex = 1;
        else if (this.boardId === 71) this.tabIndex = 2;
        else if (this.boardId === 72) this.tabIndex = 3;
        else if (this.boardId === 73) this.tabIndex = 4;
      } else if (this.boardId === 76 || this.boardId === 77) {
        this.addTab(76);
        this.addTab(77);
        this.addSubTab("형태별분류");
        if (this.boardId === 76) this.tabIndex = 0;
        else if (this.boardId === 77) this.tabIndex = 1;
      } else if (this.boardId === 78 || this.boardId === 79 || this.boardId === 87) {
        this.addTab(78);
        this.addTab(79);
        this.addTab(87);
        if (this.boardId === 78) this.tabIndex = 0;
        else if (this.boardId === 79) this.tabIndex = 1;
        else if (this.boardId === 87) this.tabIndex = 2;
      } else if (this.boardId === 80 || this.boardId === 81 || this.boardId === 88) {
        this.addTab(80);
        this.addTab(81);
        this.addTab(88);
        if (this.boardId === 80) this.tabIndex = 0;
        else if (this.boardId === 81) this.tabIndex = 1;
        else if (this.boardId === 88) this.tabIndex = 2;
      } else if (this.boardId === 82 || this.boardId === 83) {
        this.addTab(82);
        this.addTab(83);
        if (this.boardId === 82) this.tabIndex = 0;
        else if (this.boardId === 83) this.tabIndex = 1;
      } else if (this.boardId === 84 || this.boardId === 85) {
        this.addTab(84);
        this.addTab(85);
        if (this.boardId === 84) this.tabIndex = 0;
        else if (this.boardId === 85) this.tabIndex = 1;
      } else if (this.boardId === 89) {
        this.addTab(89);
        this.addSubTab("조직도");
        if (this.boardId === 89) this.tabIndex = 0;
      } else if (this.boardId === 108 || this.boardId === 156 || this.boardId === 157 || this.boardId === 158 || this.boardId === 159 || this.boardId === 305 || this.boardId === 306) {
        this.addTab(108);
        this.addTab(156);
        this.addTab(157);
        this.addTab(158);
        this.addTab(159);
        this.addTab(305);
        this.addTab(306);
        if (this.boardId === 108) this.tabIndex = 0;
        else if (this.boardId === 156) this.tabIndex = 1;
        else if (this.boardId === 157) this.tabIndex = 2;
        else if (this.boardId === 158) this.tabIndex = 3;
        else if (this.boardId === 159) this.tabIndex = 4;
        else if (this.boardId === 305) this.tabIndex = 5;
        else if (this.boardId === 306) this.tabIndex = 6;
      } else if (this.boardId === 119 || this.boardId === 120 || this.boardId === 121 || this.boardId === 122 || this.boardId === 123 || this.boardId === 124 || this.boardId === 125) {
        this.addTab(119);
        this.addTab(120);
        this.addTab(121);
        this.addTab(122);
        this.addTab(123);
        // this.addTab(124);  // 2022.12.19 https://app.clickup.com/t/864dhnpjc
        this.addTab(125);
        if (this.boardId === 119) this.tabIndex = 0;
        else if (this.boardId === 120) this.tabIndex = 1;
        else if (this.boardId === 121) this.tabIndex = 2;
        else if (this.boardId === 122) this.tabIndex = 3;
        else if (this.boardId === 123) this.tabIndex = 4;
        else if (this.boardId === 124) this.tabIndex = 5;
        else if (this.boardId === 125) this.tabIndex = 6;
      } else if (this.boardId === 144 || this.boardId === 145 || this.boardId === 146) {
        this.addTab(144);
        this.addTab(145);
        this.addTab(146);
        if (this.boardId === 144) this.tabIndex = 0;
        if (this.boardId === 145) this.tabIndex = 1;
        if (this.boardId === 146) this.tabIndex = 2;
      } else if (this.boardId === 216 || this.boardId === 217 || this.boardId === 218) {
        this.addTab(216);
        this.addTab(217);
        this.addTab(218);
        if (this.boardId === 216) this.tabIndex = 0;
        if (this.boardId === 217) this.tabIndex = 1;
        if (this.boardId === 218) this.tabIndex = 2;
      } else if (this.boardId === 239 || this.boardId === 240 || this.boardId === 241) {
        this.addTab(239);
        this.addTab(240);
        this.addTab(241);
        if (this.boardId === 239) this.tabIndex = 0;
        if (this.boardId === 240) this.tabIndex = 1;
        if (this.boardId === 241) this.tabIndex = 2;
      } /*else if (
        this.boardId === 246 ||
        this.boardId === 247 ||
        this.boardId === 248 ||
        this.boardId === 249
      ) {
        this.addTab(246);
        this.addTab(247);
        this.addTab(248);
        this.addTab(249);
        if (this.boardId === 246) this.tabIndex = 0;
        if (this.boardId === 247) this.tabIndex = 1;
        if (this.boardId === 248) this.tabIndex = 2;
        if (this.boardId === 249) this.tabIndex = 3;
      }*/ else if (this.boardId === 253 || this.boardId === 254 || this.boardId === 255) {
        this.addTab(253);
        this.addTab(254);
        this.addTab(255);
        if (this.boardId === 253) this.tabIndex = 0;
        if (this.boardId === 254) this.tabIndex = 1;
        if (this.boardId === 255) this.tabIndex = 2;
      } else if (this.boardId === 294 || this.boardId === 295) {
        this.addTab(294);
        this.addTab(295);
        if (this.boardId === 294) this.tabIndex = 0;
        if (this.boardId === 295) this.tabIndex = 1;
      } else if (this.boardId === 299 || this.boardId === 358 || this.boardId === 456) {
        if (Number(`${this.projectId}`) === 1) {
          this.addTabInLabel(358, "내부종사자");
          this.addTabInLabel(299, "도급·용역·위탁");
          this.addTabInLabel(456, "발주사업");
          if (this.boardId === 358) this.tabIndex = 0;
          if (this.boardId === 299) this.tabIndex = 1;
          if (this.boardId === 456) this.tabIndex = 2;
        } else {
          this.addTab(this.boardId);
        }
      } else if (this.boardId === 352 || this.boardId === 353 || this.boardId === 354 || this.boardId === 602) {
        this.addTab(352);
        this.addTab(353);
        this.addTab(354);
        this.addTab(602);
        if (this.boardId === 352) this.tabIndex = 0;
        if (this.boardId === 353) this.tabIndex = 1;
        if (this.boardId === 354) this.tabIndex = 2;
        if (this.boardId === 602) this.tabIndex = 3;
      } else if (this.$route.params.boardId === "현장대리인_안전보건_경영방침" || this.boardId === 284) {
        this.addSubTab("현장대리인_안전보건_경영방침");
        this.addTab(284);
        if (this.$route.params.boardId === "현장대리인_안전보건_경영방침") this.tabIndex = 0;
        if (this.boardId === 284) this.tabIndex = 1;
      } else if (this.boardId === 464 || this.boardId === 939) {
        this.addTab(464);
        this.addTab(939);
        if (this.boardId === 464) this.tabIndex = 0;
        if (this.boardId === 939) this.tabIndex = 1;
      } else if (this.boardId === 535 || this.boardId === 536) {
        this.addTab(535);
        this.addTab(536);
        if (this.boardId === 535) this.tabIndex = 0;
        if (this.boardId === 536) this.tabIndex = 1;
      } else if (this.boardId === 537 || this.boardId === 538) {
        this.addTab(537);
        this.addTab(538);
        if (this.boardId === 537) this.tabIndex = 0;
        if (this.boardId === 538) this.tabIndex = 1;
      } else if (this.boardId === 722 || this.boardId === 543) {
        this.addTab(722);
        this.addTab(543);
        if (this.boardId === 722) this.tabIndex = 0;
        if (this.boardId === 543) this.tabIndex = 1;
      } else {
        this.addTab(this.boardId);
      } /* else if (this.boardId === 285 || this.boardId === 282 || this.boardId === 283) {
        this.addTab(285);
        this.addTab(282);
        this.addTab(283);
        if (this.boardId === 285) this.tabIndex = 0;
        if (this.boardId === 282) this.tabIndex = 1;
        if (this.boardId === 283) this.tabIndex = 2;
      }*/

      for (const tab of this.tabList) {
        if (`${tab.boardId}` === `${this.boardId}`) {
          this.isApproval = tab.isApproval;
        }
      }
    },
    addTab(_boardId) {
      const slug = `board-${_boardId}`;
      const component = singlePageWrite[`${_boardId}_write`];
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({ boardId, slug, component, ...item });
      }
    },
    addTabInLabel(_boardId, label) {
      const slug = `board-${_boardId}`;
      const component = singlePageWrite[`${_boardId}_write`];
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({ boardId, slug, component, ...item });
        this.tabList[this.tabList.length - 1].label = label;
      }
    },
    addSubTab(key) {
      if (key === "아차사고D/B") this.tabList.push({
        key: "아차사고D/B",
        label: "아차사고 D/B",
        component: "exception01",
        exception: true,
      });
      if (key === "형태별분류") this.tabList.push({
        key: "형태별분류",
        label: "형태별 분류",
        component: "exception02",
        exception: true,
      });
      if (key === "조직도") this.tabList.push({
        key: "조직도",
        label: "조직도",
        component: "exception03",
        exception: true,
      });
      if (key === "현장대리인_안전보건_경영방침") this.tabList.push({ key: "현장대리인_안전보건_경영방침", label: "현장대리인 안전보건 경영방침", component: "exception04", exception: true });
    },
    moveTab(boardId, key) {
      if (boardId) {
        if (this.projectId) {
          this.$router.push({ name: "list|tab", params: { boardId } });
        } else {
          this.$router.push({ name: "root|list|tab", params: { boardId } });
        }
      }
      if (key) {
        if (key === "아차사고D/B") {
          const breadcrumb = [{ title: "아차사고" }, { title: "아차사고관리" }, { title: "아차사고 D/B" }];
          if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
          this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
        } else if (key === "현장대리인_안전보건_경영방침") {
          this.$router.push({ name: "list|tab", params: { boardId: "현장대리인_안전보건_경영방침" } });
        }
      }
    },

    // ===== API =====
    async loadBoardPost() {
      const boardId = this.boardId;
      const postId = this.$route.params.postId;
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.docProjectId = post.project_id;
      if (post.post_content) {
        this.form = JSON.parse(post.post_content);
        if (!this.form.body["fileList"]) {
          this.form.body.fileList = [];
        }
        if (!this.form.body["formList"]) {
          this.form.body.formList = [];
        }
      }
    },
    async saveBoardPost(type) {
      let childComponent = this.$refs["childComponent"];
      // 만약 childComponent 값이 배열일 경우, 배열의 첫번째 값을 가져온다
      if (Array.isArray(childComponent)) {
        childComponent = childComponent[0];
      }

      // 만약 normalDocument.validate 메서드가 존재하면 호출한다
      if (childComponent.validate) {
        const validated = childComponent.validate();
        // 검증 실패했으면 빠져나간다
        if (!validated) {
          return;
        }
      }

      const form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form.enc = this.form.body.enc;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    loadApprovalPostContent(form) {
      const body = form.body;
      if (this.boardId === 117) {
        const targetKeys = [
          "inputC_1",
          "inputC_2",
          "inputC_4",
          "inputC_5",
          "inputC_7",
          "inputC_8",
          "inputC_9",
          "inputC_10",
          "inputC_11",
          "inputC_12",
          "inputC_13",
          "inputC_14",
          "inputC_15",
          "inputC_16",
          "inputC_17",
          "inputC_18",
          "inputC_19",
          "inputC_20",
          "inputD_1",
          "inputD_2",
          "inputD_3",
          "inputD_4",
          "inputD_5",
          "inputD_6",
          "inputD_7",
          "inputE_1",
          "inputE_2",
          "inputE_3",
          "inputE_4",
        ];
        for (const key of targetKeys) {
          if (typeof form.enc !== "undefined" && typeof form.enc[key] !== "undefined") {
            body[key] = form.enc[key];
          }
        }
      } else if (this.boardId === 126) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 136) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 138) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 141) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }
      }
      return form;
    },
    async loadApprovalPost() {
      const boardSlug = this.boardSlug;
      const postId = this.$route.params.postId;
      let post = {};
      await this.$store.dispatch("approval/LOAD_POST", { boardSlug, postId }).then((value) => {
        post = value.post;
        this.docProjectId = post.id;
        return value;
      });

      if (!this.$store.state.approval.postInfo) {
        alert("열람 권한이 없습니다.");
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onMoveNormalPage("list");
        return;
      }
      // 내용
      if (post.post_content) {
        let form = JSON.parse(post.post_content);

        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }

        // enc 내용을 본문에 추가하기
        form = this.loadApprovalPostContent(form);
        this.form = form;
      }

      // TODO : 결재프로세스
      const doc = this.$store.state.approval.document;
      this.docInfo = doc;
      this.docInfo.slug = this.boardSlug;
    },
    async saveApprovalPost(type, approvalLine) {
      let childComponent = this.$refs["childComponent"];
      // 만약 normalDocument 값이 배열일 경우, 배열의 첫번째 값을 가져온다
      if (Array.isArray(childComponent)) {
        childComponent = childComponent[0];
      }

      if (childComponent.validate) {
        if (!childComponent.validate()) {
          return;
        }
      }

      let form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form = this.saveApprovalPostContent(form);

      const projectId = this.projectId;
      const boardSlug = this.boardSlug;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "n",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "create_upload") {
        await this.$store.dispatch("approval/CREATE_POST", {
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      } else if (type === "upload") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "y",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    saveApprovalPostContent(form) {
      const body = form.body;

      // 86
      if (this.boardId === 86) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 106
      else if (this.boardId === 106) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      } else if (this.boardId === 117) {
        form = this.saveApprovalPostContent117(form);
      }

      // 126
      else if (this.boardId === 126) {
        form = this.saveApprovalPostContent126(form);
      }

      // 136
      else if (this.boardId === 136) {
        form = this.saveApprovalPostContent136(form);
      }

      // 138
      else if (this.boardId === 138) {
        form = this.saveApprovalPostContent138(form);
      }

      // 141
      else if (this.boardId === 141) {
        form = this.saveApprovalPostContent141(form);
      }

      // 154
      else if (this.boardId === 154) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 155
      else if (this.boardId === 155) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 250
      else if (this.boardId === 250) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      return form;
    },

    saveApprovalPostContent117(form) {
      const body = form.body;
      const targetKeys = [
        "inputC_1",
        "inputC_2",
        "inputC_4",
        "inputC_5",
        "inputC_7",
        "inputC_8",
        "inputC_9",
        "inputC_10",
        "inputC_11",
        "inputC_12",
        "inputC_13",
        "inputC_14",
        "inputC_15",
        "inputC_16",
        "inputC_17",
        "inputC_18",
        "inputC_19",
        "inputC_20",
        "inputD_1",
        "inputD_2",
        "inputD_3",
        "inputD_4",
        "inputD_5",
        "inputD_6",
        "inputD_7",
        "inputE_1",
        "inputE_2",
        "inputE_3",
        "inputE_4",
      ];

      const maskedName = this.maskName(body.inputC_1);

      // 암호화
      form.enc = {};
      for (const key of targetKeys) {
        form.enc[key] = body[key];
        body[key] = "";
      }
      body.inputC_1 = maskedName;

      form.body = body;
      return form;
    },

    saveApprovalPostContent126(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent136(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent138(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent141(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(",", "");
        return `${Number(noneComma)}`;
      }
      return "0";
    },

    onClickApprovalClose() {
      // 닫기
      this.onMoveNormalPage("list");
    },

    //
    // ===== Approval Doc Method =====
    //
    onClickApprovalSave(approvalLine) {
      if (this.postId) {
        this.saveApprovalPost("update", approvalLine);
      } else {
        this.saveApprovalPost("create", approvalLine);
      }
    },
    onClickApprovalUpload(approvalLine) {
      // 상신
      if (this.postId) {
        this.saveApprovalPost("upload", approvalLine);
      } else {
        this.saveApprovalPost("create_upload", approvalLine);
      }
    },
    onClickApprovalRecall(approvalLine) {
      // 결재문서 회수
      if (confirm("회수 후 임시저장 상태로 변경하시겠습니까?")) {
        this.saveApprovalPost("update", approvalLine);
      }
    },
    async onClickApprovalDelete() {
      // 삭제
      if (confirm("삭제하시겠습니까?")) {
        const boardSlug = this.boardSlug;
        const postId = this.$route.params.postId;
        await this.$store.dispatch("approval/DELETE_POST", {
          boardSlug,
          postId,
        });
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onClickApprovalClose();
      }
    },
    async onClickApprovalOk() {
      // 승인
      const postId = this.$route.params.postId;
      await this.$store.dispatch("approval/APPROVE_OK", { postId });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onClickApprovalClose();
    },
    async onClickApprovalNo(text) {
      // 반려
      const postId = parseInt(this.$route.params.postId);
      const comment = text;
      await this.$store.dispatch("approval/APPROVE_NO", { postId, comment });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onClickApprovalClose();
    },
    async onClickReTempsave(approvalLine) {
      if (confirm("재상신을 할 경우,\n기존 문서는 유지 되고, 내용이 복사되어 임시저장됩니다.\n재상신 하시겠습니까?")) {
        this.saveApprovalPost("create", approvalLine);
      }
    },
    onClickCustomButton(button, buttonIndex) {
      if (this.$refs.childComponent.onClickCustomButton) {
        this.$refs.childComponent.onClickCustomButton(button, buttonIndex);
      }
    },

    //
    // ===== Normal Doc Method =====
    //
    onClickNormalSave() {
      if (this.postId) {
        this.saveBoardPost("update");
      } else {
        this.saveBoardPost("create");
      }
    },
    async onClickNormalRemove() {
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      const boardId = this.boardId;
      const postId = this.postId;
      await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    onMoveNormalPage(type) {
      const proj_id = `${this.projectId}`;
      const boardId = `${this.boardId}`;
      const query = this.$route.query;
      if (type === "list") {
        this.$router.push({ name: "list|tab", params: { proj_id, boardId }, query });
      }
    },
    saveButtonControl(value) {
      this.$refs.refNormalDocument.saveButtonControl(value);
    },
    handleEnableSave(enableSave) {
      this.enableSave = enableSave;
    },
    maskName(name) {
      if (name) {
        name = `${name}`.trim();
        // 이름이 2개 이상의 단어로 이루어져 있는 경우
        if (name.includes(" ")) {
          // 이름을 공백으로 분리
          const names = name.split(" ");
          // 성은 맨 뒤 단어로 판단
          const lastName = names[names.length - 1];
          // 나머지 이름에 대해 마스킹 처리
          const otherNames = names.slice(0, -1).map((n) => n.substring(0, Math.ceil(n.length / 2)) + "*".repeat(Math.floor(n.length / 2)));
          return [...otherNames, lastName].join(" ");
        }

        // 이름이 1개의 단어로 이루어져 있는 경우
        const length = name.length;
        if (length === 1) {
          return "*";
        } else if (length === 2) {
          return `${name[0]}*`;
        } else {
          return name[0] + "*".repeat(length - 2) + name[length - 1];
        }
      }

      return "";
    },
  },
};
</script>

<style scoped></style>
